module.exports = __webpack_public_path__ + "img/MEDIA092.874fa61f.jpg";